import { axiosInstance } from ".";

export const dashboardService = (state) => {
  return {
    async getDashboardData() {
      const response = await axiosInstance.get(`/dashboard`);
      return response?.data || [];
    },
    async getBasaksehirData() {
      const response = await axiosInstance.get(`/dashboard/basaksehir`);
      return response?.data || [];
    },
    async getSaleSpotItemProducts(showcase_id) {
      const response = await axiosInstance.get(`/dashboard/product-report-by-showcase?showcase_id=${showcase_id}`);
      return response?.data || [];
    },
    async getCustomDashboardData() {
      const response = await axiosInstance.get(`/dashboard/custom`);
      return response?.data || [];
    },
    async getBasaksehirTransactions(page, pageSize, saleSpotId) {
      const response = await axiosInstance.get(
        `/dashboard/custom-transactions?page=${page}&pageSize=${pageSize}&sale_spot_id=${saleSpotId}`
      );
      return response?.data || [];
    },
    async getBasaksehirFinancial(date) {
      const response = await axiosInstance.get(
        `/dashboard/custom-finance-report?date=${date}`
      );
      return response?.data || [];
    },
  };
};
